"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var Vocabulary = (function () {
    function Vocabulary(charToIndex, blankIndex) {
        this._charToIndex = {};
        this._indexToChar = {};
        this._blankIndex = blankIndex;
        for (var _i = 0, _a = Object.entries(charToIndex); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], v = _b[1];
            this._charToIndex[k] = v;
            this._indexToChar[v] = k;
        }
    }
    Object.defineProperty(Vocabulary.prototype, "charToIndex", {
        get: function () {
            return this._charToIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vocabulary.prototype, "indexToChar", {
        get: function () {
            return this._indexToChar;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vocabulary.prototype, "blankIndex", {
        get: function () {
            return this._blankIndex;
        },
        enumerable: true,
        configurable: true
    });
    return Vocabulary;
}());
exports.Vocabulary = Vocabulary;
exports.EN_VOCABULARY = new Vocabulary(constants_1.EN_CHAR_MAP, constants_1.EN_BLANK_INDEX);
var logSumExp = function (log1, log2) {
    if (log1 === 0) {
        return log2;
    }
    if (log2 === 0) {
        return log1;
    }
    var rev = log1 > log2 ?
        log1 + Math.log1p(Math.exp(log2 - log1)) :
        log2 + Math.log1p(Math.exp(log1 - log2));
    return rev;
};
var BeamEntry = (function () {
    function BeamEntry(seq, last) {
        this.seq = seq;
        this.pTotal = 0;
        this.pBlank = 0;
        this.pNonBlank = 0;
        this._last = -1;
        if (last) {
            this._last = last;
        }
        else {
            this._calculateLast();
        }
    }
    BeamEntry.prototype._calculateLast = function () {
        if (this.seq.length > 0) {
            this._last = this.seq[this.seq.length - 1];
        }
    };
    BeamEntry.prototype.convertToStr = function (vocabulary) {
        if (this._string === undefined) {
            this._string = this.seq.map(function (index) {
                return vocabulary.indexToChar[index];
            }).join('');
        }
        return this._string;
    };
    BeamEntry.prototype.copy = function (row, blank) {
        if (this._last === -1) {
            return undefined;
        }
        var rev = new BeamEntry(this.seq, this._last);
        if (this._parent && this._parent._last === this._last) {
            rev.pBlank = this.pTotal + blank;
        }
        else {
            rev.pBlank = this.pNonBlank + blank;
        }
        rev.pNonBlank = this.pNonBlank + row[this._last];
        rev.pTotal = logSumExp(rev.pNonBlank, rev.pBlank);
        rev._parent = this;
        return rev;
    };
    BeamEntry.prototype.extend = function (index, prob, pBlank) {
        var pNewNonBlank = 0;
        var newSeq = [];
        var pNewTotal = 0;
        var newIndex = index;
        if (this._last === -1 && index === 0) {
            pNewTotal = this.pTotal + logSumExp(prob, pBlank);
            newIndex = -1;
        }
        else if (index === this._last) {
            if (this.pBlank === 0) {
                return undefined;
            }
            else {
                pNewTotal = pNewNonBlank = this.pBlank + prob;
                newSeq = this.seq.concat([index]);
            }
        }
        else {
            pNewTotal = pNewNonBlank = this.pTotal + prob;
            newSeq = this.seq.concat([index]);
        }
        var rev = new BeamEntry(newSeq, newIndex);
        rev.pNonBlank = pNewNonBlank;
        rev.pTotal = pNewTotal;
        rev._parent = this;
        return rev;
    };
    BeamEntry.prototype.toString = function (vocabulary) {
        return this.convertToStr(vocabulary) + ", (" + this.pTotal + ")";
    };
    return BeamEntry;
}());
var BeamList = (function () {
    function BeamList(size) {
        this._size = size;
        this._beamList = [];
        this._beams = {};
    }
    BeamList.prototype.add = function (beam, vocab) {
        if (beam === undefined) {
            return;
        }
        var label = beam.convertToStr(vocab);
        var existing = this._beams[label];
        if (existing) {
            existing.pBlank = logSumExp(beam.pBlank, existing.pBlank);
            existing.pNonBlank = logSumExp(beam.pNonBlank, existing.pNonBlank);
            existing.pTotal = logSumExp(beam.pTotal, existing.pTotal);
        }
        else {
            this._beams[label] = beam;
            this._beamList.push(beam);
        }
    };
    BeamList.prototype.sort = function () {
        var rev = this._beamList.sort(function (a, b) {
            return b.pTotal - a.pTotal;
        });
        rev.length = this._size;
        return rev;
    };
    Object.defineProperty(BeamList.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    return BeamList;
}());
var CTCBeamSearch = (function () {
    function CTCBeamSearch(vocabulary) {
        this._vocabulary = vocabulary;
        this._vocabSize = Object.keys(vocabulary.charToIndex).length;
        this._blankIndex = vocabulary.blankIndex;
    }
    CTCBeamSearch.prototype.search = function (logProbs, width) {
        var _this = this;
        var beams = [
            new BeamEntry([])
        ];
        logProbs.forEach(function (row) {
            var allCandidates = new BeamList(width);
            beams.forEach(function (beam) {
                allCandidates.add(beam.copy(row, row[_this._blankIndex]), _this._vocabulary);
                for (var cIndex = 0, len = row.length; cIndex < len; cIndex++) {
                    if (cIndex !== _this._blankIndex) {
                        allCandidates.add(beam.extend(cIndex, row[cIndex], row[_this._blankIndex]), _this._vocabulary);
                    }
                }
            });
            beams = allCandidates.sort();
        });
        return beams;
    };
    Object.defineProperty(CTCBeamSearch.prototype, "vocabulary", {
        get: function () {
            return this._vocabulary;
        },
        enumerable: true,
        configurable: true
    });
    return CTCBeamSearch;
}());
exports.CTCBeamSearch = CTCBeamSearch;
//# sourceMappingURL=ctc_beam_search.js.map